import { Box, Flex, Space } from '@mantine/core';
import { translate } from '@shared/i18n/translate.tsx';
import { useParams } from '@tanstack/react-router';

import { ClubInteractionContainer } from '@/features/work-interactions/containers/ClubInteractionContainer';
import { LBBackButton } from '@/shared/modules';
import { LBLinkButton } from '@/shared/ui-kit/components';

export const ArtistWorkRequestInfoPage = () => {
  const { id: artistId, workRequestId } = useParams({
    from: '/artist/$id/work-request/$workRequestId'
  });

  return (
    <Box>
      <Flex align='center' justify='space-between'>
        <LBBackButton />
        {/* <LBLinkButton>Помощь</LBLinkButton> */}
        <LBLinkButton>{translate('commons.help')}</LBLinkButton>
      </Flex>
      <Space h={16} />
      <ClubInteractionContainer
        artistId={artistId}
        workItemId={workRequestId}
      />
      <Space h={150} />
    </Box>
  );
};
